import { SvgIcon } from "@mui/material";

function Pen(props) {
  return (
    <SvgIcon viewBox="0 0 6 10" {...props}>
      <path d="M1.6226 9.56213C1.58056 9.5884 1.53562 9.60479 1.49062 9.61027C1.44563 9.61574 1.40158 9.61018 1.36126 9.59393C1.32053 9.5783 1.2844 9.55208 1.25526 9.51701C1.22611 9.48193 1.2046 9.43879 1.19213 9.39041L0.950769 8.45009L3.05258 2.54703L4.53774 3.04846L2.43672 8.95062L1.64969 9.54352C1.64085 9.55019 1.63181 9.5564 1.6226 9.56213ZM4.6687 2.67982L3.18384 2.1782L3.57764 1.07171C3.59487 1.02323 3.61962 0.977813 3.65049 0.938062C3.68135 0.898311 3.71772 0.865005 3.75751 0.840048C3.7973 0.815091 3.83974 0.798972 3.88239 0.792614C3.92504 0.786255 3.96708 0.789781 4.00609 0.802991L4.89675 1.10388C4.93578 1.11703 4.97103 1.13962 5.00049 1.17034C5.02995 1.20105 5.05303 1.23931 5.06843 1.28291C5.08382 1.32651 5.09122 1.3746 5.0902 1.42443C5.08918 1.47427 5.07976 1.52486 5.06249 1.57333L4.66888 2.6793L4.6687 2.67982Z" />
    </SvgIcon>
  );
}

export default Pen;
